import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routers";
import version from "../utils/version";
import store from "../store";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // const user = store.state.user.user;
  // const roles = store.state.change.roles;
  // if (
  //   !to.meta ||
  //   !to.meta.minPermissionRequired ||
  //   to.meta.minPermissionRequired.length === 0 ||
  //   !user.permission ||
  //   user.permission === "admin" ||
  //   (user.permission === "staff" && !roles.length)
  // ) {
  //   //無設定最低權限存取條件，permission尚未讀取完成，admin permission 或是角色定義尚未載入完成
  //   next();
  // } else {
  //   let role = roles.find((role) => role._id === user.permissionDetail);
  //   let rolePermission = role ? role.permissions : [];
  //   if (
  //     to.meta.minPermissionRequired.find(
  //       (permission) => rolePermission.indexOf(permission) > -1
  //     )
  //   ) {
  //     next();
  //   } else {
  //     router.push({ path: "/permissionDeny" });
  //   }
  // }

  const user = store.state.user.user;
  const isLogin = store.state.user.isLogin;
  // console.log("#beforeEach", to.path, JSON.stringify(user), isLogin);
  if (
    !to.meta ||
    !to.meta.minPermissionRequired ||
    to.meta.minPermissionRequired.length === 0 ||
    user.optRoleID === "admin"
  ) {
    //無設定最低權限存取條件，admin permission
    next();
  } else {
    if (
      isLogin &&
      to.meta.minPermissionRequired.find(
        (permission) => user.optPermissions.indexOf(permission) > -1
      )
    ) {
      next();
    } else if (!isLogin) {
      return next({
        path: "/checkLogin",
        query: { redirect: to.fullPath },
      });
    } else {
      router.push({ path: "/permissionDeny" });
    }
  }
});

/*router.afterEach((to, from) => {
  // ga page view
  gtag("config", window.gtagId, {
    page_title: to.meta.title,
    page_path: `/app${to.fullPath}`,
  });
});*/

// Error Handle
router.onError((error) => {
  if (/failed/i.test(error.message)) {
    version.forceUpdate();
  }
});

export default router;
